<template>
  <svg
    fill="none"
    height="16"
    viewBox="0 0 16 16"
    width="16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.99998 14.6667C11.6666 14.6667 14.6666 11.6667 14.6666 8.00001C14.6666 4.33334 11.6666 1.33334 7.99998 1.33334C4.33331 1.33334 1.33331 4.33334 1.33331 8.00001C1.33331 11.6667 4.33331 14.6667 7.99998 14.6667Z"
      stroke="#009E60"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.16669 7.99995L7.05335 9.88661L10.8334 6.11328"
      stroke="#009E60"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
